module.exports = __webpack_public_path__ + "static/media/walking_route_dark.cc9bf1a0.svg";